import { render } from "./LoadingBoxes.vue?vue&type=template&id=d74895c6&scoped=true&ts=true"
import script from "./LoadingBoxes.vue?vue&type=script&lang=ts"
export * from "./LoadingBoxes.vue?vue&type=script&lang=ts"

import "./LoadingBoxes.vue?vue&type=style&index=0&id=d74895c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d74895c6"]])

export default __exports__